import {
  faBars,
  faBell,
  faCartShopping,
  faHeadphones,
  faHome,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Button, UnstyledButton } from "@mantine/core";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createB2BAPI } from "../../api/Interceptor";
import "./Header.css";
import logoFab from "../../assets/logoFab.jpg";
import moment from "moment";
import notify from "../../utils/Notification";
import { useMediaQuery } from "@mantine/hooks";
import NotificationDropdown from "./NotificationDropdown";
import "./NotificationCard.css";

const Header = ({ headrKey }) => {
  const navigate = useNavigate();
  const userId = JSON.parse(localStorage.getItem('user'))?.userId
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isCustomer = typeof userId === "string" && userId.startsWith("CUST-");
  const isVendor = typeof userId === "string" && userId.startsWith("VEN-") || /^B\d+$/.test(userId);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userMenuVisible, setUserMenuVisible] = useState(false);
  const [vendors, setVendors] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cartItemCount, setCartItemCount] = useState(0);
  const userIconRef = useRef(null);
  const bellIconRef = useRef(null);
  const dropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const mobileref = useRef(null);
  const location = useLocation();
  const isVendorHome = location.pathname === "/VendorHome";

  const [activeRoute, setActiveRoute] = useState(location.pathname);
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [currentTime, setCurrentTime] = useState(moment());
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [notificationPage, setNotificationPage] = useState(0);
  const [notificationTotalPages, setNotificationTotalPages] = useState(0);
  const [isMoreNotificationLoading, setIsMoreNotificationLoading] = useState(false);

  useEffect(() => {
    setCurrentTime(moment());
  }, []);

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const handleStorageChange = () => {
      const token = localStorage.getItem("token");
      setIsAuthenticated(!!token);
    };
    handleStorageChange();
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [location.pathname]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(location.pathname.toLowerCase());

    const fetchCartItemCount = async () => {
      const currentToken = localStorage.getItem("token");
      const currentAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
      if (!currentToken || !isCustomer || currentAuthPage) return;
      try {
        const response = await B2B_API.get(`cart/count`).json();
        let count = parseInt(response.response || 0, 10);
        setCartItemCount(count);
      } catch (error) {
        console.error("Failed to fetch cart count", error);
      }
    };

    let intervalId;
    if (token && isCustomer && !isAuthPage) {
      fetchCartItemCount();

      intervalId = setInterval(() => {
        const currentToken = localStorage.getItem("token");
        const currentAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
        if (!document.hidden && currentToken && isCustomer && !currentAuthPage) {
          fetchCartItemCount();
        }
      }, 10000);
    }

    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        (!userIconRef.current || !userIconRef.current.contains(event.target))
      ) {
        setUserMenuVisible(false);
      }
      if (
        notificationDropdownRef.current &&
        !notificationDropdownRef.current.contains(event.target) &&
        (!bellIconRef.current || !bellIconRef.current.contains(event.target))
      ) {
        setNotificationVisible(false);
      }
      if (mobileref.current && !mobileref.current.contains(event.target)) {
        hideSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      if (intervalId) clearInterval(intervalId);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [headrKey, isAuthenticated, isCustomer, location.pathname]);
  const handleSalesmanDownload = () => {
    const isUat = window.location.origin.includes('uat') || window.location.origin.includes('localhost');

    const url = "https://play.google.com/store/apps/details?id=com.fabinsta"

    const link = document.createElement('a');
    link.href = url;
    link.download = "Buyer.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleSalesmanDownloadSeller = () => {
    const isUat = window.location.origin.includes('uat') || window.location.origin.includes('localhost');

    const url = "https://play.google.com/store/apps/details?id=com.fabinstavendorapp"

    const link = document.createElement('a');
    link.href = url;
    link.download = "Buyer.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const toggleUserMenu = () => {
    setUserMenuVisible((prevState) => !prevState);
  };

  const navigateToHome = () => {
    { isAuthenticated ? navigate("/dashboard") : navigate("/") }
  };

  useEffect(() => {
    const fetchVendors = async () => {
      const token = localStorage.getItem("token");
      const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
      if (!token || isAuthPage) return;

      try {
        const res = await B2B_API.get(`vendor/${userId}`).json();
        const vendorData = res?.response || null;
        setVendors(vendorData);
      } catch (error) {
        notify({
          id: "fetch_vendors",
          error: true,
          success: false,
          title: error?.message || "Error fetching vendors",
        });
      }
    };
    const token = localStorage.getItem("token");
    const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(location.pathname.toLowerCase());
    if (token && !isAuthPage && (userId?.startsWith("VEN-") || /^B\d+$/.test(userId))) {
      fetchVendors();
    }
  }, [userId, isAuthenticated, location.pathname]);

  useEffect(() => {
    const featchProfile = async () => {
      const token = localStorage.getItem("token");
      const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
      if (!token || isAuthPage) return;

      try {
        setLoading(true);
        const res = await B2B_API.get("customer/profile").json();
        setProfile(res?.response);
      } catch (error) {
        console.error("Error fetching recommended items:", error);
      } finally {
        setLoading(false);
      }
    }
    const token = localStorage.getItem("token");
    const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(location.pathname.toLowerCase());
    if (token && !isAuthPage && userId?.startsWith("CUST-")) {
      featchProfile();
    }
  }, [userId, isAuthenticated, location.pathname]);

  const fetchNotifications = useCallback(async (pageNum = 0, isLoadMore = false) => {
    const token = localStorage.getItem("token");
    const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
    if (!token || isAuthPage) return;

    try {
      if (!isLoadMore) setLoading(true);
      else setIsMoreNotificationLoading(true);

      const res = await B2B_API.get(`notification/all?page=${pageNum}&size=10`).json();
      const newNotifications = res?.response?.content || [];

      if (isLoadMore) {
        setNotifications(prev => [...prev, ...newNotifications]);
      } else {
        setNotifications(newNotifications);
      }

      setNotificationTotalPages(res?.response?.totalPages || 0);
      setNotificationPage(pageNum);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
      setIsMoreNotificationLoading(true);
      setIsMoreNotificationLoading(false);
    }
  }, [B2B_API]);

  const loadMoreNotifications = () => {
    if (notificationPage + 1 < notificationTotalPages && !isMoreNotificationLoading) {
      fetchNotifications(notificationPage + 1, true);
    }
  };

  // Poll unread count every 30s; if count changes, re-fetch full notifications
  const prevUnreadCountRef = useRef(null);

  const fetchUnreadCount = useCallback(async () => {
    const token = localStorage.getItem("token");
    const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
    if (!token || isAuthPage) return;

    try {
      const res = await B2B_API.get(`notification/unread-count`).json();
      const newCount = res?.response?.unreadCount ?? 0;
      setUnreadCount(newCount);

      // If count changed from what we had before, re-fetch full notification list
      if (prevUnreadCountRef.current !== null && newCount !== prevUnreadCountRef.current) {
        setNotificationPage(0);
        fetchNotifications(0, false);
      }
      prevUnreadCountRef.current = newCount;
    } catch (error) {
      console.error("Error polling unread count:", error);
    }
  }, [B2B_API, fetchNotifications]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(location.pathname.toLowerCase());
    if (!token || (!isCustomer && !isVendor) || isAuthPage) return;

    // Initial fetch
    fetchNotifications();
    fetchUnreadCount();

    // Poll every 30 seconds
    const intervalId = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      const currentAuthPage = ['/login', '/signup', '/forgot-password', '/signupvendor'].includes(window.location.pathname.toLowerCase());
      // Only poll when tab is visible
      if (!document.hidden && currentToken && !currentAuthPage) {
        fetchUnreadCount();
      }
    }, 30000);

    return () => clearInterval(intervalId);
  }, [isCustomer, isVendor, isAuthenticated, location.pathname, fetchNotifications, fetchUnreadCount]);

  const toggleNotification = () => {
    if (isMobile) {
      navigate("/notifications");
    } else {
      setNotificationVisible(!notificationVisible);
    }
  };

  const markAllAsRead = async () => {
    try {
      await B2B_API.post("notification/mark-all-read");
      setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
      setUnreadCount(0);
    } catch (error) {
      console.error("Error marking all as read:", error);
    }
  };

  const handleNotificationClick = (item) => {
    console.log("item : ", item);
    if (!item.isRead) {
      B2B_API.post(`notification/mark-read/${item.id}`).then(() => {
        fetchNotifications();
      });
    }
    setNotificationVisible(false);
    if (item.screen === "SWATCH_REQUEST") {
      navigate(`/createDraftProduct?id=${item?.referenceId}&page=0&size=5&search=`);
    } else if (["NEW", "CONFIRMED"].includes(item.screen)) {
      navigate(`/order-Details?orderNo=${item.orderNo}`);
    } else {
      const receiptNo = item.referenceId || item.orderNo;
      navigate(`/order-Details?receiptNo=${receiptNo}`);
    }
  };


  const handleOnClick = (route) => {
    /**
     * Handle click on menu item.
     * @param {string} route path to navigate to
     * @description This function is called when a menu item is clicked.
     * It closes the user menu and sidebar, and navigates to the
     * given route with state { page: 0, contactUs: true }.
     */
    setUserMenuVisible(false);
    hideSidebar();
    navigate(route, { state: { page: 0, contactUs: true } });
  };
  const logOut = () => {
    localStorage.clear()
    setIsAuthenticated(false);
    setUserMenuVisible(false);
    navigate("/");
  };

  const showSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    if (sidebar) sidebar.style.display = "flex";
  };

  const hideSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    if (sidebar) sidebar.style.display = "none";
  };

  return (
    <nav>
      {!isAuthenticated && (
        <ul className="sidebar nav_right" ref={mobileref}>
          <li>
            <UnstyledButton onClick={hideSidebar}>
              <FontAwesomeIcon className="close_icon" icon={faXmark} />
            </UnstyledButton>
          </li>
          <li>
            <UnstyledButton onClick={() => handleOnClick("/login?role=customer")}>
              Buyer sign in
            </UnstyledButton>
          </li>
          <li>
            <UnstyledButton onClick={() => handleOnClick("/login?role=vendor")}>
              Seller sign in
            </UnstyledButton>
          </li>
          <li>
            <UnstyledButton onClick={() => handleOnClick("/home")}>
              Help Center
            </UnstyledButton>
          </li>
        </ul>
      )}
      <ul className="nav_left">
        <li >
          <span className="logo" onClick={() => navigate("/home")} ><img
            src={`${logoFab}?time=${Date.now()}`}
            alt="logo"
            style={{
              width: "100px",
              marginTop: "0.5rem",
              backgroundColor: "transparent",
            }}
          /></span>
        </li>
        {!isVendor && <li>
          <FontAwesomeIcon
            icon={faHome}
            className="home_icon"
            style={{ cursor: "pointer" }}
            onClick={navigateToHome}
          />
        </li>}
        {!isVendor && <li className="hideOnMobile">
          <Button
            className="libraryBtn"
            onClick={() => {
              navigate("/fabrics", { state: { page: 0 } });
              location.state = "";
            }}
          >
            Fabric Library
          </Button>
        </li>}
        {isVendor && <li className="hideOnMobile">
          <Button
            className="libraryBtn"
            onClick={() => {
              navigate("/VendorProducts", { state: { page: 0 } });
              location.state = "";
            }}
          >
            Vendor Library
          </Button>
        </li>}
      </ul>
      <ul className="nav_right">
        {isAuthenticated ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                columnGap: "1rem",
                alignItems: "center",
                gap: "1rem",
                justifyContent: isVendor ? "flex-end" : "flex-start",
                marginRight: isMobile ? "1.5rem" : "0.5rem",
              }}
            >
              {(isCustomer || isVendor) && (
                <li className="menu-icon notification-bell" ref={bellIconRef} onClick={toggleNotification}>
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <FontAwesomeIcon icon={faBell} />

                    {unreadCount > 0 && (
                      <Badge
                        size="sm"
                        color="#8BC53F"
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          transform: "translate(55%, -55%)",
                          minWidth: "20px",
                          height: "20px",
                          padding: "0 6px",
                          borderRadius: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "11px",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {unreadCount > 99 ? "99+" : unreadCount}
                      </Badge>
                    )}
                  </div>
                  {notificationVisible && !isMobile && (
                    <div ref={notificationDropdownRef}>
                      <NotificationDropdown
                        notifications={notifications}
                        onMarkAllRead={markAllAsRead}
                        onNotificationClick={handleNotificationClick}
                        onClose={() => setNotificationVisible(false)}
                        onLoadMore={loadMoreNotifications}
                        hasMore={notificationPage + 1 < notificationTotalPages}
                        isMoreLoading={isMoreNotificationLoading}
                      />
                    </div>
                  )}
                </li>
              )}
              {isCustomer &&
                <li onClick={() => navigate("/cart")} className="menu-icon">
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <FontAwesomeIcon icon={faCartShopping} />
                    {cartItemCount > 0 && (
                      <Badge
                        size="sm"
                        color="#8BC53F"
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          transform: "translate(55%, -55%)",
                          minWidth: "20px",
                          height: "20px",
                          padding: "0 6px",
                          borderRadius: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "11px",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {cartItemCount > 99 ? "99+" : cartItemCount}
                      </Badge>
                    )}
                  </div>
                </li>}

              {isVendor && <li>
                <div style={{ display: "flex", flexDirection: "column", gap: "-8px" }}>
                  <h1 className="Headerusername">Welcome, {vendors?.username}</h1>
                  <h1 className="HeaderCurrentDate">
                    {currentTime.format("MMMM").substring(0, 3) + currentTime.format(" D YYYY h.mm a")}
                  </h1>
                </div>
              </li>}
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                {isCustomer && !isMobile && <li>
                  <div style={{ display: "flex", flexDirection: "column", gap: "-8px" }}>
                    <h1 className="Headerusername">Welcome, {profile?.companyName}</h1>
                    <h1 className="HeaderCurrentDate">
                      {currentTime.format("MMMM").substring(0, 3) + currentTime.format(" D YYYY h.mm a")}
                    </h1>
                  </div>
                </li>}
                <li
                  onClick={toggleUserMenu}
                  className={"menu-icon profile-icon"}
                  ref={userIconRef}
                >
                  <FontAwesomeIcon icon={faUser} />
                </li>
              </div>
            </div>
            {userMenuVisible && (
              <div className="dropdown-menu" ref={dropdownRef}>
                {isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/VendorHome" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/VendorHome")}
                >
                  My Products
                </div>}
                {/* {isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/vendorFabricInquiries" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/vendorFabricInquiries")}
                >
                  New Development
                </div>} */}
                {isCustomer && <div
                  className={`dropdown-menu-item ${activeRoute === "/fabricInquiries" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/fabricInquiries")}
                >
                  Custom-Fabric Inquries
                </div>}
                {/* <div
                  className={`dropdown-menu-item ${
                    activeRoute === "/orderInquiries" ? "active" : ""
                  }`}
                >
                  Order Inquiries
                </div>
                <div
                  className={`dropdown-menu-item ${
                    activeRoute === "/bulkQuotes" ? "active" : ""
                  }`}
                >
                  Bulk Quotes
                </div> */}
                {/* <div
                  className={`dropdown-menu-item ${
                    activeRoute === "/myUltron" ? "active" : ""
                  }`}
                >
                  My Ultron
                </div> */}
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/wishList" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/wishList")}
                >
                  Wishlist
                </div>}
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/mtoInguiry" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/mtoInguiry")}
                >
                  MTO Enquiries
                </div>}
                {/* <div className={`dropdown-menu-item ${activeRoute === "/ultronOrders" ? 'active' : ''}`}>Ultron Orders</div> */}

                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/place-Orders" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/place-Orders")}
                >
                  Fabric Orders


                </div>}

                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/place-Orders" ? "actsive" : ""
                    }`}
                  onClick={() => handleOnClick("/place-Sample")}
                >
                  Sample Orders
                </div>}
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/place-Orders" ? "actisve" : ""
                    }`}
                  onClick={() => handleOnClick("/place-Swatch")}
                >
                  Swatch Orders
                </div>}
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/loyalty" ? "actsive" : ""
                    }`}
                  onClick={() => handleOnClick("/loyalty")}
                >
                  Loyalty
                </div>}
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/wallet" ? "actsive" : ""
                    }`}
                  onClick={() => handleOnClick("/wallet")}
                >
                  Wallet
                </div>}
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/place-Orders" ? "actsive" : ""
                    }`}
                  onClick={() => handleSalesmanDownload()}
                >
                  Buyer app
                </div>}
                {isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/place-Orders" ? "actsive" : ""
                    }`}
                  onClick={() => handleSalesmanDownloadSeller()}
                >
                  Seller app
                </div>}

                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/addresses" ? "actsive" : ""
                    }`}
                  onClick={() => handleOnClick("/addresses")}
                >
                  Addresses
                </div>}
                {isVendor && <div className={`dropdown-menu-item ${activeRoute === "/vendorStockAvailable" ? "active" : ""
                  }`} onClick={() => handleOnClick("/vendorStockAvailable")}>
                  Vendor Stock Available
                </div>}
                {isVendor && <div className={`dropdown-menu-item ${activeRoute === "/madeToOrder" ? "active" : ""
                  }`} onClick={() => handleOnClick("/madeToOrder")}>
                  Enquiries
                </div>}
                {isVendor && <div className={`dropdown-menu-item ${activeRoute === "/Po-Wholesale" ? "active" : ""
                  }`} onClick={() => handleOnClick("/Po-Wholesale")}>
                  Wholesale
                </div>}
                {isVendor && <div className={`dropdown-menu-item ${activeRoute === "/Po-Sample" ? "active" : ""
                  }`} onClick={() => handleOnClick("/Po-Sample")}>
                  Sample
                </div>}
                {isVendor && <div className={`dropdown-menu-item ${activeRoute === "/Po-Swatch" ? "active" : ""
                  }`} onClick={() => handleOnClick("/Po-Swatch")}>
                  Swatch
                </div>}
                <div
                  className={`dropdown-menu-item ${activeRoute === "/profile" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/profile")}
                >
                  Account
                </div>
                {!isVendor && <div
                  className={`dropdown-menu-item ${activeRoute === "/account-delete" ? "active" : ""
                    }`}
                  onClick={() => handleOnClick("/account-delete")}
                >
                  Delete my Account
                </div>}
                <div className="logout" onClick={logOut}>
                  Logout
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            <li className="hideOMobile1">
              <UnstyledButton
                onClick={() =>
                  navigate("/home", { state: { contactUs: true } })
                }
              >
                <FontAwesomeIcon icon={faHeadphones} className="help_icon" />
                <span className="help">Help Center</span>
              </UnstyledButton>
            </li>
            <li className="Btns hideOnMobile2">
              <Button className="signinBtn" onClick={() => navigate("/login?role=customer")}>
                <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                  <span style={{ letterSpacing: "0.8px" }}>Buyer </span><span className="sin"> Sign In</span>
                </div>
              </Button>
              <Button className="signinBtn2" onClick={() => navigate("/login?role=vendor")}>
                <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                  <span style={{ letterSpacing: "0.8px" }}>Seller </span><span className="sin"> Sign In</span>
                </div>
              </Button>
              {/* <Button
                className="signupBtn"
                style={{ border: "2px solid transparent" }}
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </Button> */}
            </li>
          </>
        )}
        {!isAuthenticated && (
          <li>
            <UnstyledButton onClick={showSidebar} className="menu_button">
              <FontAwesomeIcon className="menu_icon" icon={faBars} />
            </UnstyledButton>
          </li>
        )}
      </ul>
    </nav>
  );
};
export default Header;

Header.propTypes = {
  headrKey: PropTypes.string.isRequired,
};